import apiClient from '../client';
import type { AcademicSession, CreateAcademicSessionPayload, UpdateAcademicSessionPayload } from '@/types';

export const academicSessionsApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: AcademicSession[] }>('/academic-sessions', { params }).then((r) => r.data.data),

  getCurrent: () =>
    apiClient.get<{ data: AcademicSession }>('/academic-sessions/current').then((r) => r.data.data),

  getById: (id: number) =>
    apiClient.get<{ data: AcademicSession }>(`/academic-sessions/${id}`).then((r) => r.data.data),

  create: (payload: CreateAcademicSessionPayload) =>
    apiClient.post<{ data: AcademicSession }>('/academic-sessions', payload).then((r) => r.data.data),

  update: (id: number, payload: UpdateAcademicSessionPayload) =>
    apiClient.put<{ data: AcademicSession }>(`/academic-sessions/${id}`, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`/academic-sessions/${id}`),
};

